import styled from 'styled-components'

export const AccordionSection = styled.div`
  margin-bottom: 24px;
`
